import type { Request } from 'express';
import { getCookiesFromRequest } from './getCookiesFromRequest';

export function getUtmSourceFromRequest(request: Request): string {
  const cookies = getCookiesFromRequest(request);
  const utmSourceFromCookie = cookies['utm-source'];
  const utmSourceFromQuery = request.query.utm_source;
  return (utmSourceFromQuery ?? utmSourceFromCookie ?? '') as string;
}
